// src/Config/fieldRegistry.js

export const FIELD_TYPES = {
  TEXT: 'text',
  NUMBER: 'number',
  SELECT: 'select',
  MULTI_SELECT: 'multi_select',
  TEXTAREA: 'textarea',
  DATE: 'date',
  FILE: 'file',
  PRICE: 'price',
  BOOLEAN: 'boolean',
  COLOR: 'color',
  SIZE: 'size',
};


export const FIELD_REGISTRY = {

  product_name: {
    type: FIELD_TYPES.TEXT,
    label: 'Product Name',
    required: true,
    placeholder: 'Enter Product Name',
    component: 'BasicFields',
    validation: { required: true, minLength: 2 },
  },
  
  sku: {
    type: FIELD_TYPES.TEXT,
    label: 'SKU',
    required: false,
    placeholder: 'Enter SKU',
    component: 'BasicFields',
  },
  barcode: {
    type: FIELD_TYPES.TEXT,
    label: 'Barcode',
    required: false,
    placeholder: 'Enter Barcode',
    component: 'BasicFields',
  },
  brand: {
    type: FIELD_TYPES.SELECT,
    label: 'Brand',
    required: false,
    options: 'brands',
    component: 'BasicFields',
  },
  description: {
    type: FIELD_TYPES.TEXTAREA,
    label: 'Description',
    required: false,
    rows: 5,
    component: 'DescriptionFields',
  },
  status: {
    type: FIELD_TYPES.SELECT,
    label: 'Status',
    required: false,
    options: [
      { value: 1, label: 'Active' },
      { value: 0, label: 'Inactive' },
    ],
    default: 1,
    component: 'StatusFields',
  },

  // ========== CATEGORY FIELDS ==========
  category_id: {
    type: FIELD_TYPES.SELECT,
    label: 'Category',
    required: true,
    options: 'categories',
    component: 'CategoryFields',
  },
  subcategory_id: {
    type: FIELD_TYPES.SELECT,
    label: 'Sub Category',
    required: true,
    options: 'subCategories',
    component: 'CategoryFields',
    dependsOn: 'category_id',
  },
  unit_id: {
    type: FIELD_TYPES.SELECT,
    label: 'Unit',
    required: false,
    options: 'units',
    component: 'CategoryFields',
  },

  // ========== PRICING FIELDS ==========
  purchase_price: {
    type: FIELD_TYPES.PRICE,
    label: 'Purchase Price',
    required: false,
    placeholder: '0.00',
    component: 'PricingFields',
    validation: { min: 0 },
  },
  selling_price: {
    type: FIELD_TYPES.PRICE,
    label: 'Selling Price',
    required: false,
    placeholder: '0.00',
    component: 'PricingFields',
    validation: { min: 0 },
  },
  mrp: {
    type: FIELD_TYPES.PRICE,
    label: 'MRP',
    required: false,
    placeholder: '0.00',
    component: 'PricingFields',
    validation: { min: 0 },
  },


  
  // ✅ YAHAN PE YEH 2 BLOCKS ADD KARO (mrp ke neeche)
  discount: {
    type: FIELD_TYPES.NUMBER,
    label: 'Discount',
    required: false,
    placeholder: '0',
    component: 'PricingFields',
  },
discount_type: {
    type: FIELD_TYPES.SELECT,
    label: 'Discount Type',
    required: false,
    options: [  
        { value: 'flat', label: 'Flat' },
        { value: 'percentage', label: 'Percentage' }
    ],
    component: 'PricingFields',
},
  // ========== INVENTORY FIELDS ==========
  min_stock_level: {
    type: FIELD_TYPES.NUMBER,
    label: 'Minimum Stock',
    required: false,
    placeholder: '0',
    component: 'InventoryFields',
  },
  reorder_level: {
    type: FIELD_TYPES.NUMBER,
    label: 'Reorder Level',
    required: false,
    placeholder: '0',
    component: 'InventoryFields',
  },
  stock: {
    type: FIELD_TYPES.NUMBER,
    label: 'Stock',
    required: false,
    placeholder: '0',
    component: 'InventoryFields',
  },
  // ========== TAX FIELDS ==========
  gst_percentage: {
    type: FIELD_TYPES.NUMBER,
    label: 'GST %',
    required: false,
    placeholder: '18',
    component: 'TaxFields',
    validation: { min: 0, max: 100 },
  },
  hsn_code: {
    type: FIELD_TYPES.TEXT,
    label: 'HSN Code',
    required: false,
    placeholder: 'Enter HSN Code',
    component: 'TaxFields',
  },

  // ========== VARIANT FIELDS ==========
  color_ids: {
    type: FIELD_TYPES.MULTI_SELECT,
    label: 'Colors',
    required: false,
    options: 'colors',
    component: 'VariantFields',
  },
  size_ids: {
    type: FIELD_TYPES.MULTI_SELECT,
    label: 'Sizes',
    required: false,
    options: 'sizes',
    component: 'VariantFields',
  },
  model: {
    type: FIELD_TYPES.TEXT,
    label: 'Model',
    required: false,
    placeholder: 'Enter Model',
    component: 'VariantFields',
  },
  ram: {
    type: FIELD_TYPES.TEXT,
    label: 'RAM',
    required: false,
    placeholder: '8 GB',
    component: 'VariantFields',
  },
  storage: {
    type: FIELD_TYPES.TEXT,
    label: 'Storage',
    required: false,
    placeholder: '256 GB',
    component: 'VariantFields',
  },
  imei: {
    type: FIELD_TYPES.TEXT,
    label: 'IMEI',
    required: false,
    placeholder: 'Enter IMEI',
    component: 'VariantFields',
  },
  warranty: {
    type: FIELD_TYPES.TEXT,
    label: 'Warranty',
    required: false,
    placeholder: '1 Year',
    component: 'VariantFields',
  },

  // ========== MEDICINE FIELDS ==========
  batch_number: {
    type: FIELD_TYPES.TEXT,
    label: 'Batch Number',
    required: false,
    placeholder: 'Enter Batch Number',
    component: 'MedicineFields',
  },
  expiry_date: {
    type: FIELD_TYPES.DATE,
    label: 'Expiry Date',
    required: false,
    component: 'MedicineFields',
  },
  generic_name: {
    type: FIELD_TYPES.TEXT,
    label: 'Generic Name',
    required: false,
    placeholder: 'Enter Generic Name',
    component: 'MedicineFields',
  },
  dosage: {
    type: FIELD_TYPES.TEXT,
    label: 'Dosage',
    required: false,
    placeholder: 'e.g., 500mg',
    component: 'MedicineFields',
  },
  composition: {
    type: FIELD_TYPES.TEXTAREA,
    label: 'Composition',
    required: false,
    rows: 3,
    component: 'MedicineFields',
  },
  schedule: {
    type: FIELD_TYPES.SELECT,
    label: 'Schedule',
    required: false,
    options: [
      { value: 'H', label: 'Schedule H' },
      { value: 'X', label: 'Schedule X' },
      { value: 'G', label: 'Schedule G' },
    ],
    component: 'MedicineFields',
  },
  manufacturer: {
    type: FIELD_TYPES.SELECT,
    label: 'Manufacturer',
    required: false,
    options: 'manufacturers',
    component: 'MedicineFields',
  },

  // ========== SERVICE FIELDS ==========
  service_type: {
    type: FIELD_TYPES.SELECT,
    label: 'Service Type',
    required: false,
    options: [
      { value: 'One Time', label: 'One Time' },
      { value: 'Monthly', label: 'Monthly' },
      { value: 'Yearly', label: 'Yearly' },
      { value: 'Subscription', label: 'Subscription' },
    ],
    component: 'ServiceFields',
  },
  service_duration: {
    type: FIELD_TYPES.TEXT,
    label: 'Service Duration',
    required: false,
    placeholder: '30 Days / 1 Year',
    component: 'ServiceFields',
  },

  // ========== FOOD FIELDS ==========
  cuisine_type: {
    type: FIELD_TYPES.SELECT,
    label: 'Cuisine Type',
    required: false,
    options: 'cuisines',
    component: 'FoodFields',
  },
  dietary_info: {
    type: FIELD_TYPES.TEXT,
    label: 'Dietary Info',
    required: false,
    placeholder: 'Vegan, Gluten-free',
    component: 'FoodFields',
  },
  spice_level: {
    type: FIELD_TYPES.SELECT,
    label: 'Spice Level',
    required: false,
    options: [
      { value: 'Mild', label: 'Mild' },
      { value: 'Medium', label: 'Medium' },
      { value: 'Hot', label: 'Hot' },
      { value: 'Extra Hot', label: 'Extra Hot' },
    ],
    component: 'FoodFields',
  },
  prep_time: {
    type: FIELD_TYPES.TEXT,
    label: 'Preparation Time',
    required: false,
    placeholder: '15 mins',
    component: 'FoodFields',
  },
  serving_size: {
    type: FIELD_TYPES.TEXT,
    label: 'Serving Size',
    required: false,
    placeholder: '2-3 People',
    component: 'FoodFields',
  },
  allergens: {
    type: FIELD_TYPES.TEXT,
    label: 'Allergens',
    required: false,
    placeholder: 'Nuts, Gluten',
    component: 'FoodFields',
  },
  ingredients: {
    type: FIELD_TYPES.TEXTAREA,
    label: 'Ingredients',
    required: false,
    rows: 3,
    component: 'FoodFields',
  },
  property_type: {
    type: FIELD_TYPES.SELECT,
    label: 'Property Type',
    required: false,
    options: [
      { value: 'Apartment', label: 'Apartment' },
      { value: 'Villa', label: 'Villa' },
      { value: 'Studio', label: 'Studio' },
      { value: 'Penthouse', label: 'Penthouse' },
    ],
    component: 'PropertyFields',
  },
  property_size: {
    type: FIELD_TYPES.NUMBER,
    label: 'Property Size (sq.ft)',
    required: false,
    placeholder: '1000',
    component: 'PropertyFields',
  },
  bedrooms: {
    type: FIELD_TYPES.NUMBER,
    label: 'Bedrooms (BHK)',
    required: false,
    placeholder: '3',
    component: 'PropertyFields',
  },
  bathrooms: {
    type: FIELD_TYPES.NUMBER,
    label: 'Bathrooms',
    required: false,
    placeholder: '2',
    component: 'PropertyFields',
  },
  furnished: {
    type: FIELD_TYPES.BOOLEAN,
    label: 'Furnished',
    required: false,
    component: 'PropertyFields',
  },
  parking: {
    type: FIELD_TYPES.BOOLEAN,
    label: 'Parking Available',
    required: false,
    component: 'PropertyFields',
  },
  locality: {
    type: FIELD_TYPES.TEXT,
    label: 'Locality',
    required: false,
    placeholder: 'Enter Locality',
    component: 'PropertyFields',
  },

  // ========== E-COMMERCE FIELDS ==========
  weight: {
    type: FIELD_TYPES.TEXT,
    label: 'Weight',
    required: false,
    placeholder: '1 kg',
    component: 'EcommerceFields',
  },
  dimensions: {
    type: FIELD_TYPES.TEXT,
    label: 'Dimensions',
    required: false,
    placeholder: '10x20x30 cm',
    component: 'EcommerceFields',
  },
  material: {
    type: FIELD_TYPES.TEXT,
    label: 'Material',
    required: false,
    placeholder: 'Cotton, Steel',
    component: 'EcommerceFields',
  },
  color: {
    type: FIELD_TYPES.MULTI_SELECT,
    label: 'Colors',
    required: false,
    options: 'colors',
    component: 'EcommerceFields',
  },
  size: {
    type: FIELD_TYPES.MULTI_SELECT,
    label: 'Sizes',
    required: false,
    options: 'sizes',
    component: 'EcommerceFields',
  },

// ========== EXTRA SPECIFICATION FIELDS ==========
discount: {
    type: FIELD_TYPES.NUMBER,
    label: 'Discount',
    required: false,
    placeholder: '0',
    component: 'PricingFields',
},

serial_number: {
    type: FIELD_TYPES.TEXT,
    label: 'Serial Number',
    required: false,
    placeholder: 'Enter Serial Number',
    component: 'BasicFields',
},
processor: {
    type: FIELD_TYPES.TEXT,
    label: 'Processor',
    required: false,
    placeholder: 'e.g. Intel i5',
    component: 'BasicFields',
},
display_size: {
    type: FIELD_TYPES.NUMBER,
    label: 'Display Size (inches)',
    required: false,
    placeholder: 'e.g. 6.5',
    component: 'BasicFields',
},
battery_capacity: {
    type: FIELD_TYPES.NUMBER,
    label: 'Battery Capacity (mAh)',
    required: false,
    placeholder: 'e.g. 5000',
    component: 'BasicFields',
},
camera: {
    type: FIELD_TYPES.TEXT,
    label: 'Camera (MP)',
    required: false,
    placeholder: 'e.g. 48MP',
    component: 'BasicFields',
},
operating_system: {
    type: FIELD_TYPES.TEXT,
    label: 'Operating System',
    required: false,
    placeholder: 'e.g. Android 14',
    component: 'BasicFields',
},
power_rating: {
    type: FIELD_TYPES.NUMBER,
    label: 'Power Rating (W)',
    required: false,
    placeholder: 'e.g. 100',
    component: 'BasicFields',
},
// voltage: {
//     type: FIELD_TYPES.TEXT,
//     label: 'Voltage (V)',
//     required: false,
//     placeholder: 'e.g. 220',
//     component: 'BasicFields',
// },
assembly_required: {
    type: FIELD_TYPES.SELECT,
    label: 'Assembly Required',
    required: false,
    options: [
        { value: 'Yes', label: 'Yes' },
        { value: 'No', label: 'No' }
    ],
    component: 'BasicFields',
},
// expiry_date: {
//     type: FIELD_TYPES.DATE,
//     label: 'Expiry Date',
//     required: false,
//     component: 'BasicFields',
// },
organic: {
    type: FIELD_TYPES.SELECT,
    label: 'Organic',
    required: false,
    options: [
        { value: 'Yes', label: 'Yes' },
        { value: 'No', label: 'No' }
    ],
    component: 'BasicFields',
},

usage: {
    type: FIELD_TYPES.TEXT,
    label: 'Usage',
    required: false,
    placeholder: 'e.g. Apply twice daily',
    component: 'BasicFields',
},
skin_type: {
    type: FIELD_TYPES.TEXT,
    label: 'Skin Type',
    required: false,
    placeholder: 'e.g. Oily, Dry, Sensitive',
    component: 'BasicFields',
},

gemstone: {
    type: FIELD_TYPES.TEXT,
    label: 'Gemstone',
    required: false,
    placeholder: 'e.g. Diamond, Ruby',
    component: 'BasicFields',
},
certificate: {
    type: FIELD_TYPES.TEXT,
    label: 'Certificate',
    required: false,
    placeholder: 'e.g. GIA, IGI',
    component: 'BasicFields',
},
sport_type: {
    type: FIELD_TYPES.TEXT,
    label: 'Sport Type',
    required: false,
    placeholder: 'e.g. Cricket, Football',
    component: 'BasicFields',
},
skill_level: {
    type: FIELD_TYPES.TEXT,
    label: 'Skill Level',
    required: false,
    placeholder: 'e.g. Beginner, Professional',
    component: 'BasicFields',
},
fabric_type: {
    type: FIELD_TYPES.TEXT,
    label: 'Fabric Type',
    required: false,
    placeholder: 'e.g. Cotton, Polyester',
    component: 'BasicFields',
},
style: {
    type: FIELD_TYPES.TEXT,
    label: 'Style',
    required: false,
    placeholder: 'e.g. Slim Fit, Regular',
    component: 'BasicFields',
},
fit: {
    type: FIELD_TYPES.SELECT,
    label: 'Fit',
    required: false,
    options: [
        { value: 'Slim', label: 'Slim Fit' },
        { value: 'Regular', label: 'Regular Fit' },
        { value: 'Loose', label: 'Loose Fit' }
    ],
    component: 'BasicFields',
},
pattern: {
    type: FIELD_TYPES.TEXT,
    label: 'Pattern',
    required: false,
    placeholder: 'e.g. Striped, Solid',
    component: 'BasicFields',
},
gender: {
    type: FIELD_TYPES.SELECT,
    label: 'Gender',
    required: false,
    options: [
        { value: 'Men', label: 'Men' },
        { value: 'Women', label: 'Women' },
        { value: 'Unisex', label: 'Unisex' }
    ],
    component: 'BasicFields',
},
season: {
    type: FIELD_TYPES.SELECT,
    label: 'Season',
    required: false,
    options: [
        { value: 'Summer', label: 'Summer' },
        { value: 'Winter', label: 'Winter' },
        { value: 'All', label: 'All Seasons' }
    ],
    component: 'BasicFields',
},
collection: {
    type: FIELD_TYPES.TEXT,
    label: 'Collection',
    required: false,
    placeholder: 'e.g. Summer 2026',
    component: 'BasicFields',
},
occasion: {
    type: FIELD_TYPES.TEXT,
    label: 'Occasion',
    required: false,
    placeholder: 'e.g. Casual, Formal, Party',
    component: 'BasicFields',
},
sleeve_type: {
    type: FIELD_TYPES.TEXT,
    label: 'Sleeve Type',
    required: false,
    placeholder: 'e.g. Full, Half, Roll-up',
    component: 'BasicFields',
},
neck_type: {
    type: FIELD_TYPES.TEXT,
    label: 'Neck Type',
    required: false,
    placeholder: 'e.g. Polo, V-Neck, Round',
    component: 'BasicFields',
},
closure_type: {
    type: FIELD_TYPES.TEXT,
    label: 'Closure Type',
    required: false,
    placeholder: 'e.g. Button, Zipper',
    component: 'BasicFields',
},
country_of_origin: {
    type: FIELD_TYPES.TEXT,
    label: 'Country of Origin',
    required: false,
    placeholder: 'e.g. India, China',
    component: 'BasicFields',
},



  ad_type: {
    type: FIELD_TYPES.SELECT,
    label: 'Ad Type',
    required: false,
    options: [
      { value: 'Display', label: 'Display Ad' },
      { value: 'Video', label: 'Video Ad' },
      { value: 'Social Media', label: 'Social Media Ad' },
      { value: 'Search', label: 'Search Ad' },
      { value: 'Email', label: 'Email Ad' },
      { value: 'Print', label: 'Print Ad' },
      { value: 'Outdoor', label: 'Outdoor/Billboard' },
      { value: 'Influencer', label: 'Influencer Ad' },
      { value: 'Native', label: 'Native Ad' }
    ],
    component: 'ServiceFields',
  },
  platform: {
    type: FIELD_TYPES.SELECT,
    label: 'Platform',
    required: false,
    options: [
      { value: 'Google', label: 'Google Ads' },
      { value: 'Facebook', label: 'Facebook Ads' },
      { value: 'Instagram', label: 'Instagram Ads' },
      { value: 'LinkedIn', label: 'LinkedIn Ads' },
      { value: 'Twitter', label: 'Twitter Ads' },
      { value: 'YouTube', label: 'YouTube Ads' },
      { value: 'TikTok', label: 'TikTok Ads' },
      { value: 'Print Media', label: 'Print Media' },
      { value: 'TV', label: 'Television' },
      { value: 'Radio', label: 'Radio' }
    ],
    component: 'ServiceFields',
  },
  reach: {
    type: FIELD_TYPES.TEXT,
    label: 'Reach',
    required: false,
    placeholder: 'e.g., 10000, 1M',
    component: 'ServiceFields',
  },
  deliverables: {
    type: FIELD_TYPES.TEXTAREA,
    label: 'Deliverables',
    required: false,
    rows: 3,
    placeholder: 'What will be delivered?',
    component: 'ServiceFields',
  },
  // duration: {
  //   type: FIELD_TYPES.TEXT,
  //   label: 'Duration',
  //   required: false,
  //   placeholder: 'e.g., 15 Days, 1 Month',
  //   component: 'ServiceFields',
  // }

 event_type: {
    type: FIELD_TYPES.SELECT,
    label: "Event Type",
    required: true,
    options: [
      { value: "Wedding", label: "Wedding" },
      { value: "Birthday", label: "Birthday Party" },
      { value: "Corporate", label: "Corporate Event" },
      { value: "Conference", label: "Conference" },
      { value: "Seminar", label: "Seminar" },
      { value: "Exhibition", label: "Exhibition" },
      { value: "Concert", label: "Concert" },
      { value: "Product Launch", label: "Product Launch" },
      { value: "Festival", label: "Festival" },
      { value: "School Function", label: "School Function" }
    ],
    component: 'EventFields', 
  },
  event_duration: { // <-- Name change kiya (Duration unique banane ke liye)
    type: FIELD_TYPES.TEXT,
    label: "Event Duration",
    required: false,
    placeholder: "e.g. 1 Day, 3 Days, 5 Hours",
    component: 'EventFields', 
  },
  capacity: {
    type: FIELD_TYPES.NUMBER,
    label: "Guest Capacity",
    required: false,
    placeholder: "e.g. 100",
    component: 'EventFields', 
  },
  services_included: {
    type: FIELD_TYPES.TEXTAREA,
    label: "Services Included",
    required: false,
    rows: 4,
    placeholder: "Decoration, Catering, DJ, Photography, Videography, Security, Lighting, Sound System",
    component: 'EventFields', 
  },

  // ========== ENERGY & UTILITY FIELDS ==========
  wattage: {
    type: FIELD_TYPES.NUMBER,
    label: 'Wattage (kW)',
    required: false,
    placeholder: 'Enter Wattage',
    component: 'BasicFields',
  },
  efficiency: {
    type: FIELD_TYPES.NUMBER,
    label: 'Efficiency (%)',
    required: false,
    placeholder: 'e.g. 20',
    component: 'BasicFields',
  },
  power_output: {
    type: FIELD_TYPES.NUMBER,
    label: 'Power Output (MW)',
    required: false,
    placeholder: 'Enter Power',
    component: 'BasicFields',
  },
  rotor_diameter: {
    type: FIELD_TYPES.NUMBER,
    label: 'Rotor Diameter (m)',
    required: false,
    placeholder: 'Enter Diameter',
    component: 'BasicFields',
  },
  hub_height: {
    type: FIELD_TYPES.NUMBER,
    label: 'Hub Height (m)',
    required: false,
    placeholder: 'Enter Height',
    component: 'BasicFields',
  },
  project_type: {
    type: FIELD_TYPES.SELECT,
    label: 'Project Type',
    required: false,
    options: [
      { value: 'Residential', label: 'Residential' },
      { value: 'Commercial', label: 'Commercial' },
      { value: 'Industrial', label: 'Industrial' }
    ],
    component: 'ServiceFields',
  },
  voltage: {
    type: FIELD_TYPES.TEXT,
    label: 'Voltage',
    required: false,
    placeholder: 'e.g. 220V, 440V',
    component: 'ServiceFields',
  },
  panel_type: {
    type: FIELD_TYPES.TEXT,
    label: 'Panel Type',
    required: false,
    placeholder: 'e.g. AC, DC',
    component: 'ServiceFields',
  },
  pipe_size: {
    type: FIELD_TYPES.NUMBER,
    label: 'Pipe Size (inch)',
    required: false,
    placeholder: 'Enter Size',
    component: 'BasicFields',
  },
  pressure_rating: {
    type: FIELD_TYPES.NUMBER,
    label: 'Pressure Rating (PSI)',
    required: false,
    placeholder: 'Enter PSI',
    component: 'BasicFields',
  },
  temperature_rating: {
    type: FIELD_TYPES.NUMBER,
    label: 'Temperature Rating (°C)',
    required: false,
    placeholder: 'Enter Temperature',
    component: 'BasicFields',
  },
  maintenance_contract: {
    type: FIELD_TYPES.SELECT,
    label: 'Maintenance Contract',
    required: false,
    options: [
      { value: 'Yes', label: 'Yes' },
      { value: 'No', label: 'No' }
    ],
    component: 'ServiceFields',
  },
  installation_type: {
    type: FIELD_TYPES.TEXT,
    label: 'Installation Type',
    required: false,
    placeholder: 'e.g. Roof-top, Ground-mounted',
    component: 'ServiceFields',
  },
  emergency: {
    type: FIELD_TYPES.SELECT,
    label: 'Emergency Service',
    required: false,
    options: [
      { value: 'Yes', label: 'Yes' },
      { value: 'No', label: 'No' }
    ],
    component: 'ServiceFields',
  },

chemical_formula: {
    type: FIELD_TYPES.TEXT,
    label: 'Chemical Formula',
    required: false,
    placeholder: 'e.g. H2SO4, NaCl',
    component: 'BasicFields',
},

grade: {
    type: FIELD_TYPES.TEXT,
    label: 'Grade',
    required: false,
    placeholder: 'e.g. Analytical, Industrial',
    component: 'BasicFields',
},
hazards: {
    type: FIELD_TYPES.TEXT,
    label: 'Hazards',
    required: false,
    placeholder: 'e.g. Flammable, Toxic',
    component: 'BasicFields',
},
storage_conditions: {
    type: FIELD_TYPES.TEXT,
    label: 'Storage Conditions',
    required: false,
    placeholder: 'e.g. Cool, Dry Place',
    component: 'BasicFields',
},

// ========== METAL FABRICATION MISSING FIELDS ==========
finish: {
    type: FIELD_TYPES.TEXT,
    label: 'Finish',
    required: false,
    placeholder: 'e.g. Polished, Matte, Galvanized',
    component: 'BasicFields',
},
thickness: {
    type: FIELD_TYPES.NUMBER,
    label: 'Thickness (mm)',
    required: false,
    placeholder: 'e.g. 5',
    component: 'BasicFields',
},

};





